import { logger } from 'config/logger';
import { recordNewRelicCustomEvent, truncateForTelemetry } from 'shared/lib/telemetry';
import { type Response as CurrentUser } from 'shared/legacy/hooks/useCurrentUserQuery';
import type { IndeedSubscriptionAdminSource } from './useIndeedConfig.types';

export const logIndeedConfigResolution = ({
  currentUser,
  outcome,
  source,
  adminHttpStatus,
  indeedEmail,
  creditBalance,
  hasActiveSubscription,
  error,
}: {
  currentUser?: CurrentUser;
  outcome: 'success' | 'failed';
  source: IndeedSubscriptionAdminSource;
  adminHttpStatus?: number;
  indeedEmail?: string | null;
  creditBalance?: number;
  hasActiveSubscription?: boolean;
  error?: unknown;
}) => {
  try {
    recordNewRelicCustomEvent('IndeedConfigResolution', {
      tenantId: currentUser?.tenant_id ?? '',
      agentIdentifier: currentUser?.id ?? '',
      userEmail: currentUser?.email ?? '',
      rr_user_email: currentUser?.email ?? '',
      outcome,
      source,
      adminHttpStatus: adminHttpStatus ?? '',
      indeedEmail: indeedEmail ?? '',
      creditBalance: creditBalance ?? '',
      hasActiveSubscription: hasActiveSubscription === undefined ? '' : String(hasActiveSubscription),
      error: error instanceof Error ? error.message : error ? String(error) : '',
      timestamp: new Date().toISOString(),
    });
  } catch (loggingError) {
    logger.error(loggingError, { context: 'IndeedConfigResolutionLogging' });
  }
};

export const logIndeedSubscriptionInfoGraphQL = ({
  currentUser,
  outcome,
  responseBody,
  error,
}: {
  currentUser?: CurrentUser;
  outcome: 'success' | 'non_200_response' | 'missing_headers' | 'error';
  responseBody?: unknown;
  error?: unknown;
}) => {
  try {
    newrelic.addPageAction('IndeedSubscriptionInfoGraphQL', {
      tenantId: currentUser?.tenant_id ?? '',
      agentIdentifier: currentUser?.id ?? '',
      outcome,
      responseBody: truncateForTelemetry(responseBody),
      error: error instanceof Error ? error.message : error ? String(error) : '',
      timestamp: new Date().toISOString(),
    });
  } catch (loggingError) {
    logger.error(loggingError, { context: 'IndeedSubscriptionInfoGraphQLLogging' });
  }
};

export const logIndeedProxyResponseError = ({
  currentUser,
  response,
}: {
  currentUser?: CurrentUser;
  response: { status?: number; body?: unknown; headers?: unknown };
}) => {
  try {
    newrelic.addPageAction('IndeedProxyResponseError', {
      tenantId: currentUser?.tenant_id ?? '',
      agentIdentifier: currentUser?.id ?? '',
      status: response.status ?? '',
      body: truncateForTelemetry(response.body),
      timestamp: new Date().toISOString(),
    });
  } catch (loggingError) {
    logger.error(loggingError, { context: 'IndeedProxyResponseErrorLogging' });
  }
};
